<template>
  <div id="app">
    <appHeader v-if="this.$route.name !== 'login'" />
    <router-view :key="$route.path" />
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import Header from "./components/shared/Header";
export default {
  components: {
    appHeader: Header,
  },
};
</script>